module.exports = __webpack_public_path__ + "img/placeholder.bce117a7.jpg";